import baseAPI from '@/api';
import { CreateBettingSessionDemoInputDto } from '@/services/dto/betiing-session/create-betting-session-demo-input.dto';
import { CreateBettingSessionDemoOutputDto } from '@/services/dto/betiing-session/create-betting-session-demo-output.dto';
import { AxiosResponse } from 'axios';

export async function fetchCreateBettingSessionDemo(
  data: CreateBettingSessionDemoInputDto,
): Promise<CreateBettingSessionDemoOutputDto> {
  const response: AxiosResponse<CreateBettingSessionDemoOutputDto> =
    await baseAPI.post<CreateBettingSessionDemoOutputDto>(
      '/betting-sessions/demo',
      data,
    );

  return response.data;
}
